import { useTranslation } from "react-i18next";
import { SubscriptionPlan } from "./contracts/SubscriptionPlan";

interface BillingCycleToggleProps {
  value: SubscriptionPlan;
  onChange: (plan: SubscriptionPlan) => void;
  disabled?: boolean;
}

/** Segmented Monthly / Annual control driving the plan offer below it. */
const BillingCycleToggle = ({ value, onChange, disabled }: BillingCycleToggleProps) => {
  const { t } = useTranslation();

  const option = (plan: SubscriptionPlan, label: string, tag?: string) => {
    const active = value === plan;
    return (
      <button
        type="button"
        onClick={() => onChange(plan)}
        disabled={disabled}
        aria-pressed={active}
        className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${
          active
            ? "bg-white text-grey-20 shadow-sm dark:bg-primary-10 dark:text-white"
            : "text-grey-50 hover:text-grey-20 dark:text-grey-70 dark:hover:text-white"
        }`}
      >
        {label}
        {tag && (
          <span className="whitespace-nowrap rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-900/30 dark:text-green-300">
            {tag}
          </span>
        )}
      </button>
    );
  };

  return (
    <div className="inline-flex gap-1 rounded-2xl bg-primary-95 p-1 dark:bg-primary-20">
      {option(SubscriptionPlan.Monthly, t("subscription.page.plans.cycleMonthly"))}
      {option(
        SubscriptionPlan.Annual,
        t("subscription.page.plans.cycleAnnual"),
        t("subscription.page.plans.annualSavingsTag")
      )}
    </div>
  );
};

export default BillingCycleToggle;
